export default __webpack_public_path__ + "static/London-c9ebd185fe89aa523b7210db51288006.jpg";